<template>
  <div>
    <Row>
      <Form ref="queryRecordsForm" :model="query" :label-width="70" label-position="right" inline
            class="index-query-form">
        <Form-item :label-width="0">
          <Input
            v-model="query.transId"
            placeholder="请输入交易流水号"
            style="width:170px;margin-right: 10px;"
          />
          <Input
            v-model="query.gate"
            placeholder="请输入车道号"
            style="width:170px;margin-right: 10px;"
          />
          <span @click="handleSearch" style="margin: 0 10px;"><Button
            type="primary">{{$t('searchText')}}</Button></span>
          <Button @click="resetSearchForm" type="default">{{$t('resetText')}}</Button>
        </Form-item>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1" style="width:100%;">
      <Table ref="recordsTable" :columns="columns" stripe border :data="page.data"
             @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle">
        <Page :current="page.current" :total="page.total" :page-size="page.size" @on-change="handlePageChange"
              show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
  </div>
</template>
<script type="text/jsx">
  import Vue from 'vue'

  import api from '@/api'
  import mixin from '@/libs/mixins/Index'

  export default {
    name: 'aip-travel-payRecords-index',
    mixins: [mixin],
    data () {
      return {
        query: {
          gate: '',
          transId: ''
        },
        page: {
          size: 10,
          current: 1,
          total: 0,
          sort: 'id_desc',
          loading: false,
          data: []
        },
        recordsDrawer: {
          action: 'add',
          visible: false,
          submiting: false
        },
        batchOperate: {
          action: '',
          submiting: false,
          options: [
            { value: 'handleBatchRemove', label: '批量删除' }
          ]
        }
      }
    },
    methods: {
      handleSearch () {
        this.page.loading = true
        api.travel.PayRecords.query(this.query, this.page)
          .then(data => {
            this.page = Object.assign(this.page, data)
            this.page.loading = false
          }).catch(error => this.page.loading = false)
      },
      openRecordsDrawer (records) {
        this.recordsDrawer.visible = true
        this.recordsDrawer.type = records ? records.type : 'add'
        this.$nextTick(() => {
          if (records) {
            this.$refs['recordsForm'].getRecords(records.id, records.type)
          } else {
            this.$refs['recordsForm'].handleReset()
          }
        })
      },
      handleSubmit () {
        this.recordsDrawer.submiting = true
        this.$refs.recordsForm.handleSubmit(
          data => {
            this.recordsDrawer.submiting = false
            this.handleSearch()
            setTimeout(() => this.recordsDrawer.visible = false, 1000)
          },
          () => {
            this.recordsDrawer.submiting = false
          }
        )
      },
      deleteRecords (id) {
        api.travel.PayRecords.remove(id)
          .then(response => {
            this.$Message.success(this.$t('successText'))
            this.handleSearch()
          }).catch(error => console.log(error))
      },
      handleBatchRemove (rows) {
        this.batchOperate.submiting = true
        Promise.all(rows.map(item => api.travel.PayRecords.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false
            this.handleSearch()
          }).catch(e => {
          this.batchOperate.submiting = false
          this.handleSearch()
        })
      }
    },
    computed: {
      columns () {
        return [
          { key: 'transId', align: 'center', minWidth: 120, fixed: 'left', title: '交易流水编号' },
          { key: 'inId', align: 'center', minWidth: 120, title: '进出场id' },
          { key: 'plateNo', align: 'center', minWidth: 120, title: '车牌号' },
          { key: 'amount', align: 'center', minWidth: 120, title: '金额（元）' },
          { key: 'gate', align: 'center', minWidth: 120, title: '车道号' },
          { key: 'payTime', align: 'center', width: 170, title: '支付时间' },
          { key: 'crossTime', align: 'center', width: 170, title: '通行时间' }
        ]
      }
    }
  }
</script>
